import React from 'react';
import {FiltersDropdownComp} from './FiltersDropdown';
import {dropdownRef} from './DropdownRef';

export function renderDropdown(root) {
    root.render(<FiltersDropdownComp ref={dropdownRef} />);
}
